module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-1-summer-355170258c71f402ea70ec0cfb5d2c8b.jpg";